module.exports = __webpack_public_path__ + "img/prize-05.66185a42.png";